// Parses a Ruby base-64 encoded JSON
export const parseB64Json = (encodedString) => {
  const baseString = atob(encodedString);

  // Properly decode UTF-8 characters
  const utfString = decodeURIComponent(
    baseString
      .split("")
      .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
      .join(""),
  );

  return JSON.parse(utfString);
};
